import { Link, useNavigate } from 'react-router-dom'
import LogoImg from '../../assets/images/econn-logo.png'
import './Error404.css'

const Error404 = () => {
    const navigate = useNavigate();

    const goBack = (e) => {
        e.preventDefault();
        navigate(-1); // go back one step in history
    };

    return (
        <div className="error-page-wrapper">
            <img src={LogoImg} alt="eConn logo" />
            <h3>Page Not Found</h3>
            <h5><a href="#" onClick={goBack}>Back</a></h5>
            <h5><Link to="/">Home</Link></h5>
        </div>
    );
}

export default Error404;
